export const paths = {
  home: '/',
  checkout: '/checkout',
  contact: '/contact',
  pricing: '/pricing',
  auth: {
    custom: {
      signIn: '/auth/custom/sign-in',
      signUp: '/auth/custom/sign-up',
      resetPassword: '/auth/custom/reset-password',
    },
    auth0: {
      callback: '/auth/auth0/callback',
      signIn: '/auth/auth0/sign-in',
      signUp: '/auth/auth0/sign-up',
      signOut: '/auth/auth0/sign-out',
      profile: '/auth/auth0/profile',
    },
    cognito: {
      signIn: '/auth/cognito/sign-in',
      signUp: '/auth/cognito/sign-up',
      signUpConfirm: '/auth/cognito/sign-up-confirm',
      newPasswordRequired: '/auth/cognito/new-password-required',
      resetPassword: '/auth/cognito/reset-password',
      updatePassword: '/auth/cognito/update-password',
    },
    firebase: {
      signIn: '/auth/firebase/sign-in',
      signUp: '/auth/firebase/sign-up',
      resetPassword: '/auth/firebase/reset-password',
      recoveryLinkSent: '/auth/firebase/recovery-link-sent',
      updatePassword: '/auth/firebase/update-password',
    },
    // supabase: {
    //   callback: { implicit: '/auth/supabase/callback/implicit', pkce: '/auth/supabase/callback/pkce' },
    //   signIn: '/auth/supabase/sign-in',
    //   signUp: '/auth/supabase/sign-up',
    //   signUpConfirm: '/auth/supabase/sign-up-confirm',
    //   resetPassword: '/auth/supabase/reset-password',
    //   recoveryLinkSent: '/auth/supabase/recovery-link-sent',
    //   updatePassword: '/auth/supabase/update-password',
    // },
    samples: {
      signIn: { centered: '/auth/samples/sign-in/centered', split: '/auth/samples/sign-in/split' },
      signUp: { centered: '/auth/samples/sign-up/centered', split: '/auth/samples/sign-up/split' },
      updatePassword: {
        centered: '/auth/samples/update-password/centered',
        split: '/auth/samples/update-password/split',
      },
      resetPassword: { centered: '/auth/samples/reset-password/centered', split: '/auth/samples/reset-password/split' },
      verifyCode: { centered: '/auth/samples/verify-code/centered', split: '/auth/samples/verify-code/split' },
    },
  },
  dashboard: {
    overview: '/dashboard',

    settings: {
      website: '/dashboard/settings/website',
      general: '/dashboard/settings/general',
      userSignup: '/dashboard/settings/user-signup',
      wagering: '/dashboard/settings/wagering',
      tiers: '/dashboard/settings/tiers',
      account: '/dashboard/settings/account',
      integrations: '/dashboard/settings/integrations',
      notifications: '/dashboard/settings/notifications',
      security: '/dashboard/settings/security',
      team: '/dashboard/settings/team',
      translation: '/dashboard/settings/translation',
      gameManagement: '/dashboard/settings/game-management',
    },
    staff_settings: {
      all_staff: '/dashboard/staff-settings/all-staff',
      roles: '/dashboard/staff-settings/roles',
      details: (opId?: string | string[], userId?: string) => {
        const resolvedOpId = Array.isArray(opId) ? opId[0] : opId;
        return `/dashboard/staff-settings/all-staff/${resolvedOpId ?? ''}/${userId ?? ''}`;
      },
      permissions: `/dashboard/staff-settings/permissions`,
      user_permissions: (userId: string) => `/dashboard/staff-settings/permissions/${userId}`,
    },
    billing: {
      billing_payments: '/dashboard/billing/billing-payments',
    },
    techSupport: {
      cfAccounts: '/dashboard/tech-support/cf-accounts',
      domains: '/dashboard/tech-support/domains',
      export: '/dashboard/tech-support/export',
      servers: '/dashboard/tech-support/servers',
      afds: '/dashboard/tech-support/afds',
    },
    operators: {
      operators: '/dashboard/operators',
      brands: '/dashboard/brands',
      newBrand: '/dashboard/brands/new',

      details: (opId: string) => `/dashboard/operators/${opId}`,
    },
    support: {
      all: '/dashboard/support',
      direct: (threadType: string, threadId: string) => `/dashboard/support/${threadType}/${threadId}`,
      // new: `/dashboard/support/new`,
      // pending: `/dashboard/support/pending`,
      // assigned: `/dashboard/support/assigned`,
      // replied: `/dashboard/support/replied`,
    },
    bets: {
      allBets: '/dashboard/bets',
      casinoOpenBets: `/dashboard/bets?type=casino`,
      playerBets: (playerCode: string) => `/dashboard/bets?playerCode=${playerCode}`,
    },
    deposit: {
      allDeposit: '/dashboard/deposit',
    },
    withdraw: {
      allWithdraw: '/dashboard/withdraw',
      withdrawAccounts: '/dashboard/withdraw/bank-accounts',
    },
    transactions: {
      allTransactions: '/dashboard/transactions/all-transactions',
      playerTransactions: (playerCode: string) => `/dashboard/transactions/all-transactions?playerCode=${playerCode}`,
    },
    cashback: {
      allCashback: '/dashboard/cashback/all',
      cashbackSettings: '/dashboard/cashback/settings',
    },
    bonus: {
      bonusDefinition: '/dashboard/bonus/bonus-definition',
      newBonusDefinition: `/dashboard/bonus/bonus-definition/new`,
      editBonusDefinition: (bonusId: string, opId: string) => `/dashboard/bonus/bonus-definition/${opId}/${bonusId}`,
      bonusRelease: '/dashboard/bonus/bonus-release',
      editBonusRelease: (bonusId: string, opId: string) => `/dashboard/bonus/bonus-release/${opId}/${bonusId}`,
      claims: `/dashboard/bonus/claims`,
    },
    tournament: {
      tournamentList: '/dashboard/tournament/list',
      tournamentWinners: '/dashboard/tournament/winners',
      winnerDetails: (id: string) => `/dashboard/tournament/winners/${id}`,
    },
    partners: {
      list: '/dashboard/partners/list',
      new: '/dashboard/partners/new',
    },
    cms: {
      branding: '/dashboard/cms/branding',
      theme: '/dashboard/cms/theme',
      fileStorage: '/dashboard/cms/file-storage',
      mainPage: {
        slider: '/dashboard/cms/main-page/slider',
        cards: '/dashboard/cms/main-page/cards',
        gameCards: '/dashboard/cms/main-page/game-cards',
        bonusCards: '/dashboard/cms/main-page/bonus-cards',
        loginImage: '/dashboard/cms/main-page/login-image',
        article: '/dashboard/cms/main-page/article',
        widgets: '/dashboard/cms/main-page/widgets',
        secondaryBanner: '/dashboard/cms/main-page/secondary-banner',
        footer: '/dashboard/cms/main-page/footer',
      },
      pages: {
        list: '/dashboard/cms/pages',
        new: '/dashboard/cms/pages/new',
        edit: (slug: string) => `/dashboard/cms/pages/${slug}`,
      },
      modals: {
        list: '/dashboard/cms/modals',
        new: '/dashboard/cms/modals/new',
        edit: (slug: string) => `/dashboard/cms/modals/${slug}`,
      },
      blog: {
        list: '/dashboard/cms/blog',
        new: '/dashboard/cms/blog/new',
        edit: (slug: string) => `/dashboard/cms/blog/${slug}`,
      },
    },
    crm: {
      telegram: '/dashboard/crm/telegram',
    },
    news: {
      whatsNew: '/dashboard/whats-new',
    },
    academy: { browse: '/dashboard/academy', details: (courseId: string) => `/dashboard/academy/courses/${courseId}` },
    analytics: '/dashboard/analytics',
    blank: '/dashboard/blank',
    blog: {
      list: '/dashboard/blog',
      details: (postId: string) => `/dashboard/blog/${postId}`,
      create: '/dashboard/blog/create',
    },
    calendar: '/dashboard/calendar',
    chat: {
      base: '/dashboard/chat',
      compose: '/dashboard/chat/compose',
      thread: (threadType: string, threadId: string) => `/dashboard/chat/${threadType}/${threadId}`,
    },
    crypto: '/dashboard/crypto',
    customers: {
      list: '/dashboard/customers',
      create: '/dashboard/customers/create',
      details: (customerId: string) => `/dashboard/customers/${customerId}`,
    },
    players: {
      list: '/dashboard/players/all',
      usernames: `/dashboard/players/usernames`,
      kyc: `/dashboard/players/kyc`,
      details: (playerId: string) => `/dashboard/players/${playerId}`,
    },
    eCommerce: '/dashboard/e-commerce',
    fileStorage: '/dashboard/file-storage',
    i18n: '/dashboard/i18n',
    invoices: {
      list: '/dashboard/invoices',
      create: '/dashboard/invoices/create',
      details: (invoiceId: string) => `/dashboard/invoices/${invoiceId}`,
    },
    jobs: {
      browse: '/dashboard/jobs',
      create: '/dashboard/jobs/create',
      companies: {
        overview: (companyId: string) => `/dashboard/jobs/companies/${companyId}`,
        reviews: (companyId: string) => `/dashboard/jobs/companies/${companyId}/reviews`,
        activity: (companyId: string) => `/dashboard/jobs/companies/${companyId}/activity`,
        team: (companyId: string) => `/dashboard/jobs/companies/${companyId}/team`,
        assets: (companyId: string) => `/dashboard/jobs/companies/${companyId}/assets`,
      },
    },
    logistics: { metrics: '/dashboard/logistics', fleet: '/dashboard/logistics/fleet' },
    mail: {
      list: (label: string) => `/dashboard/mail/${label}`,
      details: (label: string, emailId: string) => `/dashboard/mail/${label}/${emailId}`,
    },
    orders: {
      list: '/dashboard/orders',
      create: '/dashboard/orders/create',
      preview: (orderId: string) => `/dashboard/orders?previewId=${orderId}`,
      details: (orderId: string) => `/dashboard/orders/${orderId}`,
    },
    products: {
      list: '/dashboard/products',
      create: '/dashboard/products/create',
      preview: (productId: string) => `/dashboard/products?previewId=${productId}`,
      details: (productId: string) => `/dashboard/products/${productId}`,
    },
    social: {
      profile: { timeline: '/dashboard/social/profile', connections: '/dashboard/social/profile/connections' },
      feed: '/dashboard/social/feed',
    },
    tasks: '/dashboard/tasks',
  },
  pdf: { invoice: (invoiceId: string) => `/pdf/invoices/${invoiceId}` },
  components: {
    index: '/components',
    buttons: '/components/buttons',
    charts: '/components/charts',
    colors: '/components/colors',
    detailLists: '/components/detail-lists',
    forms: '/components/forms',
    gridLists: '/components/grid-lists',
    groupedLists: '/components/grouped-lists',
    inputs: '/components/inputs',
    modals: '/components/modals',
    quickStats: '/components/quick-stats',
    tables: '/components/tables',
    typography: '/components/typography',
  },
  notAuthorized: '/errors/not-authorized',
  notFound: '/errors/not-found',
  internalServerError: '/errors/internal-server-error',
  docs: 'https://material-kit-pro-react-docs.devias.io',
  purchase: 'https://mui.com/store/items/devias-kit-pro',
} as const;
